// Utility to clean up old tenant_id localStorage key and ensure consistency
export const cleanupTenantIdStorage = (): void => {
  try {
    const selectedTenantId = localStorage.getItem("selectedTenantId");
    const oldTenantId = localStorage.getItem("tenant_id");
    
    // If we have the old tenant_id but not the new selectedTenantId, migrate it
    if (!selectedTenantId && oldTenantId) {
      localStorage.setItem("selectedTenantId", oldTenantId);
    }
    
    // Remove the old tenant_id key to avoid confusion
    localStorage.removeItem("tenant_id");
  } catch (error) {
    console.warn("Error cleaning up tenant ID storage:", error);
  }
};

// Call this function on app initialization to ensure storage consistency
export const initializeStorageCleanup = (): void => {
  // Run cleanup on app load
  cleanupTenantIdStorage();
  
  // Also run cleanup when storage changes in other tabs
  window.addEventListener('storage', (event) => {
    if (event.key === 'tenant_id' && event.newValue) {
      cleanupTenantIdStorage();
    }
  });
};